<template>
  <div class="">
    <h1 class="mt-3">Zeiterfassung Benutzer</h1>
    <div v-if="showUser">
      <timeTrackingUser
        @cancel="showUser = !showUser"
        @save="createUser"
      ></timeTrackingUser>
    </div>
    <div v-if="!showUser">
      <button @click="currentYear--">&lt;</button
      ><input class="mx-1" v-model="currentYear" /><button
        @click="currentYear++"
      >
        &gt;
      </button>
      <div v-for="tib in timetrackingTibs" :key="tib.id">
        <timeTrackingDetails
          :hidden="true"
          :tibId="tib.id"
          :json="tib.data"
          :allowEdit="true"
          :title="tib.description"
          :year="currentYear"
          :templateUrl="templateUrl"
          @save="save"
        ></timeTrackingDetails>
      </div>

      <button
        @click="showUser = !showUser"
        type="button"
        class="mt-3 btn btn-outline-dark btn-block"
        data-dismiss="modal"
      >
        <i class="fas fa-plus"></i>&nbsp;Benutzer hinzufügen
      </button>
    </div>
  </div>
</template>

<script>
import {
  newYearTracking,
  getYearFromTimestamp
} from "@/common/timetrackingutils";
import { TT_URL } from "@/common/constants";
import { getCookie } from "@/common/utils";
import axios from "axios";

import timeTrackingDetails from "@/components/timetracking/TimeTrackingDetails.vue";
import timeTrackingUser from "@/components/timetracking/TimeTrackingUser.vue";

export default {
  name: "timeTrackingUsers",
  components: {
    timeTrackingDetails,
    timeTrackingUser
  },
  data: function() {
    return {
      currentYear: null,
      timetrackingTibs: null,
      showUser: false,
      templateUrl: ""
    };
  },
  mounted() {
    this.currentYear = getYearFromTimestamp(new Date());
    this.loadUsers();
    this.initTemplateUrl();
  },
  methods: {
    loadUsers() {
      let self = this;
      axios
        .post(TT_URL + "/api/rest/tibtix/listPersonalTibsByPath", {
          path: "/timetracking"
        })
        .then(response => {
          // filter result by year
          self.timetrackingTibs = response.data.filter(
            tib => tib.name == self.currentYear.toString()
          );
          self.timetrackingTibs.sort((a, b) => {
            return a.description
              .toLowerCase()
              .localeCompare(b.description.toLowerCase());
          });

          let nowYear = getYearFromTimestamp(new Date());
          let nextYear = nowYear + 1;
          if (self.currentYear == nextYear) {
            this.createTibsForNextYearIfNeeded(response.data, nextYear);
          }
        })
        .catch(function(error) {
          self.$emit("error", "An error has occurred." + "\n" + error);
        });
    },
    initTemplateUrl() {
      for (let tib of this.templateTibs) {
        // TODO check name of tib?
        this.templateUrl = tib.url;
      }
    },
    createTibsForNextYearIfNeeded(allTimeTrackingTibs, nextYear) {
      let self = this;
      let currentYearTimeTrackingTibs = allTimeTrackingTibs.filter(
        tib => tib.name == (nextYear - 1).toString()
      );
      let nextYearTimeTrackingTibs = allTimeTrackingTibs.filter(
        tib => tib.name == nextYear.toString()
      );

      for (const currentYearTimeTrackingTib of currentYearTimeTrackingTibs) {
        let found = false;
        for (const nextYearTimeTrackingTib of nextYearTimeTrackingTibs) {
          if (
            currentYearTimeTrackingTib.connectionKey ==
            nextYearTimeTrackingTib.connectionKey
          ) {
            found = true;
            break;
          }
        }
        if (!found) {
          this.createTib(
            nextYear.toString(),
            "/timetracking",
            "",
            "_object",
            "timetracking",
            JSON.stringify(newYearTracking()),
            currentYearTimeTrackingTib.description,
            currentYearTimeTrackingTib.connectionKey,
            tib => {
              self.timetrackingTibs.push(tib);
            }
          );
        }
      }
    },
    save(tibId, json) {
      for (const timetrackingTib of this.timetrackingTibs) {
        if (timetrackingTib.id == tibId) {
          timetrackingTib.data = json;
          this.updateTib(timetrackingTib);
        }
      }
    },
    updateTib(tib) {
      let self = this;
      axios
        .post(TT_URL + "/api/rest/tibtix/updateTib", tib)
        // eslint-disable-next-line
        .then(response => {
          console.info("saved");
        })
        .catch(function(error) {
          self.$emit("error", "An error has occurred." + "\n" + error);
        });
    },
    createUser(userdata) {
      console.info("createuser: " + userdata.email);
      // check if connection for this email exists

      // create client
      let self = this;
      axios
        .post(
          TT_URL +
            "/api/rest/" +
            getCookie("lastdomainname") +
            "/connection/addClient",
          userdata
        )
        .then(response => {
          console.info("client created");
          if (response.data) {
            self.createTimetrackingTib(
              response.data.id,
              response.data.displayName
            );
            self.showUser = false;
          } else {
            self.$emit("error", "An error has occurred.\n" + response.status);
          }
        })
        .catch(function(error) {
          self.$emit("error", "An error has occurred." + "\n" + error);
        });
    },
    createTimetrackingTib(connectionId, userDisplayName) {
      let self = this;
      let year = getYearFromTimestamp(new Date()).toString();

      for (const timetrackingTib of this.timetrackingTibs) {
        if (
          timetrackingTib.connectionKey == connectionId &&
          timetrackingTib.name == year
        ) {
          return;
        }
      }

      this.createTib(
        year,
        "/timetracking",
        "",
        "_object",
        "timetracking",
        JSON.stringify(newYearTracking()),
        userDisplayName,
        connectionId,
        tib => {
          self.timetrackingTibs.push(tib);
        }
      );
      this.createTib(
        "Servicekleber App starten",
        "/",
        "https://www.tibtix.com/tt/view/app/be77d403-dad7-4161-93e3-6ae3d345f264/",
        "_default",
        "redirect",
        "",
        "",
        connectionId,
        null
      );
    },
    createTib(
      name,
      path,
      url,
      tibType,
      type,
      data1,
      description,
      connectionKey,
      callback
    ) {
      let self = this;
      axios
        .post(TT_URL + "/api/rest/tibtix/createTib", {
          name: name,
          path: path,
          url: url,
          tibType: tibType,
          type: type,
          data: data1,
          contentAccess: "Open",
          description: description,
          connectionKey: connectionKey
        })
        .then(response => {
          if (callback) {
            callback.call(self, response.data);
          }
        })
        .catch(function(error) {
          self.$emit("error", "An error has occurred." + "\n" + error);
        });
    }
  },
  watch: {
    currentYear() {
      this.loadUsers();
    },
    timetrackingTibs: {
      deep: true
    }
  },
  props: ["templateTibs"]
};
</script>
